export default __webpack_public_path__ + "e4606a37eb3516785bf39bebf9e4e384.svg";